var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178.497,
    height: 55.924,
    viewBox: "0 0 178.497 55.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6273",
    "data-name": "Group 6273",
    transform: "translate(-14.173 -20.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8749",
    "data-name": "Path 8749",
    d: "M17.462,298.546v-2.169h-2.5v2.169h-.788V293.6h.788v2.088h2.5V293.6h.79v4.949Z",
    transform: "translate(0 -222.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8750",
    "data-name": "Path 8750",
    d: "M46.021,298.546V293.6h2.643l-.24.676H46.81v1.4h1.606v.677H46.81v1.515h1.862v.676Z",
    transform: "translate(-25.921 -222.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8751",
    "data-name": "Path 8751",
    d: "M69.11,298.546V293.6h.781v4.272H71.7v.676Z",
    transform: "translate(-44.715 -222.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6273-2",
    "data-name": "Group 6273",
    transform: "translate(28.099 70.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8752",
    "data-name": "Path 8752",
    d: "M90.48,298.419a2.621,2.621,0,0,1-1.464-.427l.331-.594a1.962,1.962,0,0,0,1.1.369c.4,0,.879-.183.879-.633,0-.759-1.194-.908-1.8-1.577a1.257,1.257,0,0,1-.337-.884,1.376,1.376,0,0,1,1.554-1.325,2.481,2.481,0,0,1,1.171.272l-.008.735a2.219,2.219,0,0,0-1.126-.344c-.428,0-.782.18-.782.569,0,.977,2.163.949,2.163,2.464,0,.834-.735,1.375-1.689,1.375",
    transform: "translate(-89.016 -293.348)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3902",
    "data-name": "Rectangle 3902",
    width: 0.788,
    height: 4.949,
    transform: "translate(32.824 70.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6274",
    "data-name": "Group 6274",
    transform: "translate(35.461 33.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8753",
    "data-name": "Path 8753",
    d: "M132.183,298.547l-2.33-3.041a7.4,7.4,0,0,1-.495-.715h-.015c.015.166.015.407.015.647v3.108h-.78V293.6h.8l2.237,2.929a6.032,6.032,0,0,1,.519.745h.015c-.008-.2-.015-.451-.015-.694V293.6h.789v4.949Z",
    transform: "translate(-128.578 -256.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8754",
    "data-name": "Path 8754",
    d: "M162.147,298.419a2.366,2.366,0,0,1-2.476-2.485,2.519,2.519,0,0,1,2.686-2.586,3.666,3.666,0,0,1,1.436.28l-.008.758a3.006,3.006,0,0,0-1.374-.368,1.725,1.725,0,0,0-1.892,1.84,1.753,1.753,0,0,0,1.83,1.892,1.781,1.781,0,0,0,.835-.165v-1.7h.788v2.1a4,4,0,0,1-1.824.437",
    transform: "translate(-153.886 -256.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8755",
    "data-name": "Path 8755",
    d: "M193.774,298.548h-1.458V293.6h1.5a1.247,1.247,0,0,1,1.382,1.217,1.112,1.112,0,0,1-.63,1.052v0a1.221,1.221,0,0,1,.945,1.2c0,.692-.472,1.472-1.741,1.472m-.668-4.265v1.4h.562a.711.711,0,0,0,.729-.72c0-.415-.247-.684-.79-.684Zm.668,2.08h-.668v1.508h.631c.64,0,.962-.315.962-.789,0-.419-.346-.72-.925-.72",
    transform: "translate(-180.456 -256.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8756",
    "data-name": "Path 8756",
    d: "M216.485,294.071a2.627,2.627,0,0,1,3.672.052,2.773,2.773,0,0,1-.09,3.605,2.475,2.475,0,0,1-1.788.691,2.375,2.375,0,0,1-2.5-2.51,2.58,2.58,0,0,1,.706-1.839m1.794-.038a1.87,1.87,0,1,0,1.661,1.864,1.656,1.656,0,0,0-1.661-1.864",
    transform: "translate(-199.553 -256.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8757",
    "data-name": "Path 8757",
    d: "M253.008,298.547c-.773-1.275-1.156-1.952-1.351-2H251.2v2h-.788V293.6h1.231c1.238,0,1.713.623,1.713,1.382a1.4,1.4,0,0,1-.932,1.307v.007a12.594,12.594,0,0,1,1.5,2.252Zm-1.359-4.265h-.45v1.644h.466a.864.864,0,0,0,.885-.863c0-.427-.262-.781-.9-.781",
    transform: "translate(-227.741 -256.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8758",
    "data-name": "Path 8758",
    d: "M276.99,298.419a2.367,2.367,0,0,1-2.479-2.485,2.521,2.521,0,0,1,2.688-2.586,3.654,3.654,0,0,1,1.435.28l-.006.758a3.008,3.008,0,0,0-1.375-.368,1.727,1.727,0,0,0-1.894,1.84,1.891,1.891,0,0,0,2.666,1.727v-1.7h.79v2.1a4.007,4.007,0,0,1-1.824.437",
    transform: "translate(-247.357 -256.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8759",
    "data-name": "Path 8759",
    d: "M154.635,101.414h0a.291.291,0,1,1-.291.291.291.291,0,0,1,.291-.291",
    transform: "translate(-149.55 -99.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8760",
    "data-name": "Path 8760",
    d: "M153.84,94.427a2.39,2.39,0,0,0,0-.665.733.733,0,0,1-.36.092,1.055,1.055,0,0,1,.161-.555.987.987,0,0,1-.766,0,1.058,1.058,0,0,1,.161.555.733.733,0,0,1-.361-.092,2.39,2.39,0,0,0,0,.665.735.735,0,0,1,.361-.092.852.852,0,0,1-.145.484l.031.024a.421.421,0,0,1,.67,0l.032-.024a.851.851,0,0,1-.145-.484.734.734,0,0,1,.36.092",
    transform: "translate(-148.173 -93.298)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8761",
    "data-name": "Path 8761",
    d: "M143.442,105.126l-2.849,2.217v.916h.8v-.916h1.646v.916h.8v-.916h1.646v.916h.8v-.916Z",
    transform: "translate(-102.897 -69.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8762",
    "data-name": "Path 8762",
    d: "M141.36,119.31v.916h-1.646v-.916h-.8v.916h-1.646v-.916h-.8v.916h-1.646v-.916h-.8v1.7h8.147v-1.7Z",
    transform: "translate(-97.543 -80.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6275",
    "data-name": "Group 6275",
    transform: "translate(31.318 39.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8763",
    "data-name": "Path 8763",
    d: "M106.312,124.2a.34.34,0,1,1,.34.34.34.34,0,0,1-.34-.34",
    transform: "translate(-106.312 -123.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8764",
    "data-name": "Path 8764",
    d: "M97.754,129.838v-1.217h-.34v1.217l-2.243,2.867h7.5v-2.867Z",
    transform: "translate(-65.926 -88.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6276",
    "data-name": "Group 6276",
    transform: "translate(30.601 39.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8765",
    "data-name": "Path 8765",
    d: "M107.519,154.576h-.851v-.934a.437.437,0,0,1,.851,0Zm-1.558,0h-.851v-.934a.437.437,0,0,1,.851,0Zm-1.558,0h-.851v-.934a.437.437,0,0,1,.851,0Zm-1.94.7h6.145V152.84h-6.145Z",
    transform: "translate(-102.463 -147.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8766",
    "data-name": "Path 8766",
    d: "M202.524,124.2a.34.34,0,1,0-.34.34.34.34,0,0,0,.34-.34",
    transform: "translate(-183.352 -123.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8767",
    "data-name": "Path 8767",
    d: "M181.24,129.838v-1.217h.34v1.217l2.243,2.867h-7.5v-2.867Z",
    transform: "translate(-131.976 -88.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6277",
    "data-name": "Group 6277",
    transform: "translate(25.062 20.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8768",
    "data-name": "Path 8768",
    d: "M177.41,153.642a.436.436,0,0,1,.851,0v.934h-.851Zm1.558,0a.436.436,0,0,1,.851,0v.934h-.851Zm1.558,0a.436.436,0,0,1,.851,0v.934h-.851Zm-4.206,1.631h6.146V152.84H176.32Z",
    transform: "translate(-157.037 -128.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8769",
    "data-name": "Path 8769",
    d: "M94.307,171.547l3.487-3.363H91.483s-2.131.736-2.131,2.36a1.635,1.635,0,0,0,.381,1Z",
    transform: "translate(-86.252 -140.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8770",
    "data-name": "Path 8770",
    d: "M180.579,171.547l-3.487-3.363H183.4s2.131.736,2.131,2.36a1.634,1.634,0,0,1-.382,1Z",
    transform: "translate(-157.666 -140.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8771",
    "data-name": "Path 8771",
    d: "M131.069,159.8l-4.152-5.479,5.618,5.571a1.745,1.745,0,0,1-.637.116,1.51,1.51,0,0,1-.829-.208m-2.023,0-2.693-5.717,4.242,5.787a1.718,1.718,0,0,1-.7.141,1.87,1.87,0,0,1-.85-.211m-2.085-.013-1.024-5.885,2.675,5.954a1.526,1.526,0,0,1-.714.155,2.872,2.872,0,0,1-.938-.224m-1.353.224a2.1,2.1,0,0,1-.937-.167l.938-6.093.937,6.094a2.109,2.109,0,0,1-.938.167m-3-.154,2.676-5.954-1.024,5.885a2.876,2.876,0,0,1-.938.224,1.532,1.532,0,0,1-.714-.154m-1.983.013,4.242-5.787-2.693,5.718a1.841,1.841,0,0,1-.849.21,1.723,1.723,0,0,1-.7-.141m-1.939.026,5.617-5.571-4.152,5.479a1.513,1.513,0,0,1-.829.208,1.741,1.741,0,0,1-.637-.116",
    transform: "translate(-110.123 -128.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8772",
    "data-name": "Path 8772",
    d: "M97.527,190.8h-.851v-.934a.437.437,0,0,1,.851,0Zm-3.967-.934a.437.437,0,0,1,.851,0v.934h-.851Zm1.558,0a.437.437,0,0,1,.851,0v.934h-.851Zm2.312-1.338H92.942v4.2h.58v1.652h2.684v-1.652h1.939v-4a1.985,1.985,0,0,1-.714-.2",
    transform: "translate(-89.174 -157.178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8773",
    "data-name": "Path 8773",
    d: "M191.524,189.866a.437.437,0,0,1,.851,0v.935h-.851Zm3.967.935h-.851v-.935a.437.437,0,0,1,.851,0Zm-1.558,0h-.851v-.935a.437.437,0,0,1,.851,0Zm-3.027-2.072v4h1.939v1.652h2.684v-1.652h.58v-4.2H191.62a2,2,0,0,1-.714.2",
    transform: "translate(-168.909 -157.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8774",
    "data-name": "Path 8774",
    d: "M134.224,191.552H133.1v-1.606a.579.579,0,0,1,1.128,0Zm-1.969,0h-1.4v-1.719a.718.718,0,0,1,1.4,0Zm-2.291,0h-1.4v-1.719a.718.718,0,0,1,1.4,0Zm-2.291,0h-1.4v-1.719a.718.718,0,0,1,1.4,0Zm-2.24,0h-1.127v-1.606a.578.578,0,0,1,1.127,0Zm9.12-3.234a2.076,2.076,0,0,1-1,.242,2.29,2.29,0,0,1-1.017-.244,1.9,1.9,0,0,1-.981.244,3.269,3.269,0,0,1-1.091-.252,2.324,2.324,0,0,1-1.2.252h-.008a2.325,2.325,0,0,1-1.2-.252,3.269,3.269,0,0,1-1.091.252,1.9,1.9,0,0,1-.981-.244,2.287,2.287,0,0,1-1.016.244,2.077,2.077,0,0,1-1-.242,1.929,1.929,0,0,1-.8.233v3.993h1.484V194.2h2.684v-1.651h3.845V194.2h2.685v-1.651h1.484v-3.993a1.928,1.928,0,0,1-.8-.233",
    transform: "translate(-113.781 -156.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8775",
    "data-name": "Path 8775",
    d: "M140,132.417h-.851v-.934a.436.436,0,0,1,.851,0Zm.707-.934a.436.436,0,0,1,.851,0v.934h-.851Zm1.558,0a.436.436,0,0,1,.851,0v.934h-.851Zm-1.83,2.076.7-.7.7.7-.516.516,3.195,3.082v-6.423h-6.753v6.423l3.195-3.082Z",
    transform: "translate(-125.652 -110.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8776",
    "data-name": "Path 8776",
    d: "M102.749,56.174H99.89v1.652H96.045V56.174H93.361v1.652H89.516V56.174H86.832v1.652H82.987V56.174H80.3v1.652H76.458V56.174H73.6V32.508h29.151Zm-.131-36.125V20.5h-.7v-.455h-1.04V20.5h-.7v-.455h-1.04v1.222H99.6v1.864H98.83v1.254H97.463V23.136h-.771V21.271h.469V20.049H96.12V20.5h-.7v-.455h-1.04V20.5h-.7v-.455h-1.04v1.222H93.1v1.864h-.771v1.254H90.739V23.136h-.771V21.271h.468V20.049H89.4V20.5h-.7v-.455h-1.04V20.5h-.7v-.455h-1.04v1.222h.469v1.864h-.771v1.254h-1.48V23.136h-.771V21.271h.469V20.049h-1.04V20.5h-.7v-.455h-1.04V20.5h-.7v-.455H79.3v1.222h.469v1.864H79v1.254h-1.48V23.136h-.771V21.271h.469V20.049h-1.04V20.5h-.7v-.455h-1.04V20.5h-.7v-.455H72.69v1.222h.469v3.118l1.809,1.923v3.013h-.9v2.909h-.744V60.252c0,1.759.882,2.789,2.776,3.242,2.924.7,7.023,1.682,9.947,2.386a2.59,2.59,0,0,1,2,1.771l.129.365.13-.365a2.59,2.59,0,0,1,2-1.771c2.922-.7,7.022-1.686,9.947-2.386,1.894-.453,2.776-1.484,2.776-3.242V32.234h-.744V29.325h-.9V26.312l1.809-1.923V21.271h.469V20.049Z",
    transform: "translate(-72.69 -20.049)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "H22_Logo_Hbg_The_making_Neg-1",
    transform: "translate(79.914 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6281",
    "data-name": "Group 6281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6279",
    "data-name": "Group 6279",
    transform: "translate(39.054 28.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6278",
    "data-name": "Group 6278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8777",
    "data-name": "Path 8777",
    d: "M336.106,246.017H335.4v-4h-4.771v4h-.7V237.67h.7v3.749H335.4V237.67h.711Z",
    transform: "translate(-329.369 -237.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8778",
    "data-name": "Path 8778",
    d: "M396.931,261.021a2.688,2.688,0,0,1-1.431-.39,2.658,2.658,0,0,1-1-1.086,3.391,3.391,0,0,1-.355-1.562v-.246a3.643,3.643,0,0,1,.347-1.611,2.756,2.756,0,0,1,.966-1.126,2.382,2.382,0,0,1,1.342-.409,2.238,2.238,0,0,1,1.791.771,3.125,3.125,0,0,1,.663,2.107v.384h-4.426v.132a2.6,2.6,0,0,0,.605,1.757,1.925,1.925,0,0,0,1.522.7,2.244,2.244,0,0,0,.972-.2,2.14,2.14,0,0,0,.765-.642l.431.327A2.511,2.511,0,0,1,396.931,261.021Zm-.126-5.847a1.714,1.714,0,0,0-1.3.568,2.622,2.622,0,0,0-.645,1.526h3.721v-.074a2.279,2.279,0,0,0-.51-1.456A1.582,1.582,0,0,0,396.805,255.173Z",
    transform: "translate(-385.889 -252.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8779",
    "data-name": "Path 8779",
    d: "M448.5,242.655h-.688V233.85h.688Z",
    transform: "translate(-433.107 -233.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8780",
    "data-name": "Path 8780",
    d: "M468.881,259.321a.978.978,0,0,0-.411-.82,3.164,3.164,0,0,0-1.235-.484,5.627,5.627,0,0,1-1.282-.4,1.7,1.7,0,0,1-.676-.553,1.375,1.375,0,0,1-.221-.791,1.476,1.476,0,0,1,.613-1.212,2.477,2.477,0,0,1,1.57-.479,2.557,2.557,0,0,1,1.665.513,1.646,1.646,0,0,1,.628,1.338h-.688a1.111,1.111,0,0,0-.456-.906,2.055,2.055,0,0,0-2.235-.06.926.926,0,0,0-.409.783.845.845,0,0,0,.341.719,3.587,3.587,0,0,0,1.245.467,5.913,5.913,0,0,1,1.353.453,1.751,1.751,0,0,1,.667.579,1.591,1.591,0,0,1-.415,2.076,2.707,2.707,0,0,1-1.654.471,2.781,2.781,0,0,1-1.757-.525,1.615,1.615,0,0,1-.673-1.328h.688a1.2,1.2,0,0,0,.507.938,2.079,2.079,0,0,0,1.235.336,1.954,1.954,0,0,0,1.158-.316A.943.943,0,0,0,468.881,259.321Z",
    transform: "translate(-448.102 -252.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8781",
    "data-name": "Path 8781",
    d: "M515.2,237.231a.459.459,0,0,1,.126-.328.452.452,0,0,1,.344-.133.461.461,0,0,1,.347.133.456.456,0,0,1,.128.328.445.445,0,0,1-.128.324.464.464,0,0,1-.347.131.455.455,0,0,1-.344-.131A.45.45,0,0,1,515.2,237.231Zm.808,7.994h-.688v-6.2h.688Z",
    transform: "translate(-492.407 -236.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8782",
    "data-name": "Path 8782",
    d: "M536.943,254.694l.023,1.061a2.46,2.46,0,0,1,.871-.874,2.268,2.268,0,0,1,1.152-.3,1.862,1.862,0,0,1,1.485.562,2.536,2.536,0,0,1,.493,1.685V260.9h-.682v-4.077a1.891,1.891,0,0,0-.353-1.238,1.383,1.383,0,0,0-1.109-.407,1.734,1.734,0,0,0-1.126.4,2.347,2.347,0,0,0-.726,1.076V260.9h-.682v-6.2h.653Z",
    transform: "translate(-510.966 -252.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8783",
    "data-name": "Path 8783",
    d: "M586.891,257.738a3.732,3.732,0,0,1,.645-2.307,2.082,2.082,0,0,1,1.751-.851,2.158,2.158,0,0,1,1.927,1.008l.035-.894h.641v6.077a2.627,2.627,0,0,1-.671,1.9,2.4,2.4,0,0,1-1.817.7,2.754,2.754,0,0,1-1.235-.289,2.414,2.414,0,0,1-.927-.771l.384-.413a2.173,2.173,0,0,0,1.731.894,1.762,1.762,0,0,0,1.342-.508,2.021,2.021,0,0,0,.5-1.407v-.78a2.217,2.217,0,0,1-1.921.917,2.069,2.069,0,0,1-1.731-.859,3.744,3.744,0,0,1-.653-2.322v-.092Zm.694.12a3.226,3.226,0,0,0,.477,1.871,1.541,1.541,0,0,0,1.342.685,1.834,1.834,0,0,0,1.795-1.136V256.4a1.958,1.958,0,0,0-.694-.909,1.867,1.867,0,0,0-1.089-.312,1.558,1.558,0,0,0-1.347.679A3.441,3.441,0,0,0,587.585,257.858Z",
    transform: "translate(-555.491 -252.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8784",
    "data-name": "Path 8784",
    d: "M647.49,239.617a3.73,3.73,0,0,1-.642,2.3,2.049,2.049,0,0,1-1.725.851,2.232,2.232,0,0,1-1.961-.963l-.029.849h-.642V233.85h.682v3.5a2.157,2.157,0,0,1,1.938-1.014,2.068,2.068,0,0,1,1.739.84,3.779,3.779,0,0,1,.64,2.336v.1Zm-.687-.12a3.224,3.224,0,0,0-.477-1.894,1.552,1.552,0,0,0-1.342-.669,1.888,1.888,0,0,0-1.118.324,1.963,1.963,0,0,0-.694.948V241A1.838,1.838,0,0,0,645,242.173a1.54,1.54,0,0,0,1.328-.671A3.451,3.451,0,0,0,646.8,239.5Z",
    transform: "translate(-604.417 -233.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8785",
    "data-name": "Path 8785",
    d: "M693.26,257.695a3.643,3.643,0,0,1,.347-1.611,2.607,2.607,0,0,1,2.417-1.514,2.551,2.551,0,0,1,2.006.868,3.342,3.342,0,0,1,.768,2.3v.144a3.69,3.69,0,0,1-.347,1.619,2.587,2.587,0,0,1-.977,1.109,2.675,2.675,0,0,1-1.439.39,2.555,2.555,0,0,1-2-.868,3.332,3.332,0,0,1-.771-2.3v-.138Zm.688.19a2.815,2.815,0,0,0,.576,1.826,1.948,1.948,0,0,0,3.016,0,2.906,2.906,0,0,0,.576-1.883v-.132a3.164,3.164,0,0,0-.264-1.3,2.128,2.128,0,0,0-.74-.915,1.888,1.888,0,0,0-1.089-.324,1.832,1.832,0,0,0-1.5.719,2.912,2.912,0,0,0-.58,1.883v.127Z",
    transform: "translate(-649.092 -252.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8786",
    "data-name": "Path 8786",
    d: "M753.547,255.279a2.6,2.6,0,0,0-.465-.04A1.667,1.667,0,0,0,752,255.6a1.961,1.961,0,0,0-.634,1.041V260.9h-.682v-6.2h.671l.011.986a1.826,1.826,0,0,1,1.749-1.1,1.145,1.145,0,0,1,.454.074Z",
    transform: "translate(-699.619 -252.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8787",
    "data-name": "Path 8787",
    d: "M779.581,257.738a3.732,3.732,0,0,1,.645-2.307,2.082,2.082,0,0,1,1.751-.851,2.158,2.158,0,0,1,1.927,1.008l.035-.894h.641v6.077a2.627,2.627,0,0,1-.671,1.9,2.4,2.4,0,0,1-1.817.7,2.754,2.754,0,0,1-1.235-.289,2.413,2.413,0,0,1-.927-.771l.384-.413a2.173,2.173,0,0,0,1.731.894,1.761,1.761,0,0,0,1.342-.508,2.021,2.021,0,0,0,.5-1.407v-.78a2.217,2.217,0,0,1-1.921.917,2.069,2.069,0,0,1-1.731-.859,3.747,3.747,0,0,1-.653-2.322v-.092Zm.694.12a3.226,3.226,0,0,0,.477,1.871,1.541,1.541,0,0,0,1.342.685,1.834,1.834,0,0,0,1.795-1.136V256.4a1.959,1.959,0,0,0-.694-.909,1.867,1.867,0,0,0-1.089-.312,1.558,1.558,0,0,0-1.347.679A3.441,3.441,0,0,0,780.275,257.858Z",
    transform: "translate(-725.05 -252.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8788",
    "data-name": "Path 8788",
    d: "M330.6,340.929a1.356,1.356,0,0,0-.487-1.1,5.16,5.16,0,0,0-1.783-.768,6.244,6.244,0,0,1-1.892-.793,1.926,1.926,0,0,1-.061-3.15,3.238,3.238,0,0,1,2.016-.6,3.336,3.336,0,0,1,1.489.322,2.443,2.443,0,0,1,1.018.894,2.343,2.343,0,0,1,.361,1.278h-.711a1.752,1.752,0,0,0-.585-1.377,2.278,2.278,0,0,0-1.571-.521,2.476,2.476,0,0,0-1.525.427,1.337,1.337,0,0,0-.568,1.116,1.265,1.265,0,0,0,.51,1.04,4.739,4.739,0,0,0,1.634.709,7.688,7.688,0,0,1,1.7.637,2.416,2.416,0,0,1,.872.789,1.978,1.978,0,0,1,.293,1.083,1.885,1.885,0,0,1-.789,1.582,3.359,3.359,0,0,1-2.078.6,4.055,4.055,0,0,1-1.619-.316,2.479,2.479,0,0,1-1.119-.882,2.278,2.278,0,0,1-.382-1.3h.706a1.669,1.669,0,0,0,.659,1.394,2.792,2.792,0,0,0,1.754.51,2.608,2.608,0,0,0,1.565-.43A1.349,1.349,0,0,0,330.6,340.929Z",
    transform: "translate(-325.33 -322.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8789",
    "data-name": "Path 8789",
    d: "M385.476,358.107l.1.533.138-.562,1.491-4.747h.585l1.473,4.707.161.653.132-.6,1.272-4.759h.711l-1.805,6.2h-.585l-1.593-4.919-.074-.339-.074.345-1.565,4.913h-.585l-1.8-6.2h.7Z",
    transform: "translate(-376.482 -338.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8790",
    "data-name": "Path 8790",
    d: "M458.921,358.821a2.688,2.688,0,0,1-1.431-.39,2.658,2.658,0,0,1-1-1.086,3.391,3.391,0,0,1-.355-1.562v-.246a3.642,3.642,0,0,1,.347-1.611,2.756,2.756,0,0,1,.966-1.126,2.382,2.382,0,0,1,1.342-.409,2.238,2.238,0,0,1,1.791.771,3.125,3.125,0,0,1,.663,2.107v.384h-4.426v.132a2.6,2.6,0,0,0,.605,1.757,1.925,1.925,0,0,0,1.522.7,2.244,2.244,0,0,0,.972-.2,2.14,2.14,0,0,0,.765-.642l.431.327A2.509,2.509,0,0,1,458.921,358.821Zm-.126-5.847a1.714,1.714,0,0,0-1.3.568,2.621,2.621,0,0,0-.645,1.526h3.721v-.074a2.279,2.279,0,0,0-.51-1.456A1.58,1.58,0,0,0,458.8,352.973Z",
    transform: "translate(-440.437 -338.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8791",
    "data-name": "Path 8791",
    d: "M507.31,337.288a3.743,3.743,0,0,1,.645-2.3,2.078,2.078,0,0,1,1.751-.857,2.155,2.155,0,0,1,1.915.992v-3.48h.682v8.805h-.642l-.029-.826a2.216,2.216,0,0,1-1.937.94,2.066,2.066,0,0,1-1.729-.863,3.761,3.761,0,0,1-.655-2.33v-.078Zm.694.121a3.226,3.226,0,0,0,.477,1.871,1.541,1.541,0,0,0,1.342.685,1.847,1.847,0,0,0,1.8-1.118v-2.913a1.832,1.832,0,0,0-1.789-1.21,1.558,1.558,0,0,0-1.347.679A3.455,3.455,0,0,0,508,337.409Z",
    transform: "translate(-485.464 -319.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8792",
    "data-name": "Path 8792",
    d: "M562.931,358.821a2.688,2.688,0,0,1-1.431-.39,2.657,2.657,0,0,1-1-1.086,3.391,3.391,0,0,1-.355-1.562v-.246a3.643,3.643,0,0,1,.347-1.611,2.756,2.756,0,0,1,.966-1.126,2.382,2.382,0,0,1,1.342-.409,2.238,2.238,0,0,1,1.791.771,3.125,3.125,0,0,1,.663,2.107v.384h-4.426v.132a2.6,2.6,0,0,0,.605,1.757,1.925,1.925,0,0,0,1.522.7,2.244,2.244,0,0,0,.972-.2,2.14,2.14,0,0,0,.765-.642l.431.327A2.508,2.508,0,0,1,562.931,358.821Zm-.126-5.847a1.714,1.714,0,0,0-1.3.568,2.622,2.622,0,0,0-.645,1.526h3.721v-.074a2.279,2.279,0,0,0-.51-1.456A1.58,1.58,0,0,0,562.805,352.973Z",
    transform: "translate(-531.961 -338.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8793",
    "data-name": "Path 8793",
    d: "M614.044,352.494l.023,1.061a2.46,2.46,0,0,1,.872-.874,2.268,2.268,0,0,1,1.152-.3,1.862,1.862,0,0,1,1.485.562,2.536,2.536,0,0,1,.493,1.685V358.7h-.682v-4.077a1.9,1.9,0,0,0-.353-1.239,1.382,1.382,0,0,0-1.109-.407,1.734,1.734,0,0,0-1.126.4,2.346,2.346,0,0,0-.726,1.076V358.7h-.683v-6.2Z",
    transform: "translate(-578.81 -338.151)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6280",
    "data-name": "Group 6280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8794",
    "data-name": "Path 8794",
    d: "M331.959,20.364H318.19V17.632l6.5-6.925a16.028,16.028,0,0,0,1.98-2.552,4.1,4.1,0,0,0,.641-2.07,3.074,3.074,0,0,0-.676-2.1,2.437,2.437,0,0,0-1.931-.766,2.634,2.634,0,0,0-2.132.932A3.687,3.687,0,0,0,321.79,6.6h-4a6.582,6.582,0,0,1,.876-3.353,6.177,6.177,0,0,1,2.477-2.38A7.525,7.525,0,0,1,324.772,0a7.131,7.131,0,0,1,4.822,1.49A5.27,5.27,0,0,1,331.312,5.7a6.736,6.736,0,0,1-.773,3.035,16.885,16.885,0,0,1-2.649,3.6l-4.566,4.815h8.637v3.216Z",
    transform: "translate(-279.641 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8795",
    "data-name": "Path 8795",
    d: "M467,20.364H453.231V17.632l6.5-6.925a16.027,16.027,0,0,0,1.98-2.552,4.1,4.1,0,0,0,.641-2.07,3.074,3.074,0,0,0-.676-2.1,2.441,2.441,0,0,0-1.931-.766,2.634,2.634,0,0,0-2.132.932,3.687,3.687,0,0,0-.779,2.449h-4a6.582,6.582,0,0,1,.876-3.353,6.178,6.178,0,0,1,2.477-2.38A7.525,7.525,0,0,1,459.812,0a7.131,7.131,0,0,1,4.822,1.49A5.27,5.27,0,0,1,466.352,5.7a6.736,6.736,0,0,1-.773,3.035,16.884,16.884,0,0,1-2.649,3.6l-4.566,4.815H467v3.216Z",
    transform: "translate(-398.471 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8796",
    "data-name": "Path 8796",
    d: "M25.842,2.3V19.047H4.139V2.3H0V22.387H29.98V2.3Z",
    transform: "translate(0 -2.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8797",
    "data-name": "Path 8797",
    d: "M0,257.757H4.139V241.01h21.7v16.747H29.98V237.67H0Z",
    transform: "translate(0 -209.139)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.b2aa087e4adb1232f49abb1d23ae0856.svg";
export { ForwardRef as ReactComponent };